import { render } from "./FirstStepsPage.vue?vue&type=template&id=e3d70ada"
import script from "./FirstStepsPage.vue?vue&type=script&lang=js"
export * from "./FirstStepsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__